import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('@/pages/home/page'));
const CustomPage = lazy(() => import('@/pages/custom/page'));
const EnterprisePage = lazy(() => import('@/pages/enterprise/page'));
const AfricaPage = lazy(() => import('@/pages/africa/page'));
const PolarPage = lazy(() => import('@/pages/polar/page'));
const AboutPage = lazy(() => import('@/pages/about/page'));
const ContactPage = lazy(() => import('@/pages/contact/page'));
const DestinationsPage = lazy(() => import('@/pages/destinations/page'));
const DestinationDetailPage = lazy(() => import('@/pages/destinations/detail'));
const ThemesPage = lazy(() => import('@/pages/themes/page'));
const ThemeDetailPage = lazy(() => import('@/pages/themes/detail'));
const AcademyPage = lazy(() => import('@/pages/academy/page'));
const ExplorePage = lazy(() => import('@/pages/explore/page'));
const CustomServicePage = lazy(() => import('@/pages/custom-service/page'));
const WikiPage = lazy(() => import('@/pages/wiki/page'));
const AfricaWikiPage = lazy(() => import('@/pages/wiki/africa/page'));
const WikiArticlePage = lazy(() => import('@/pages/wiki/africa/article'));
const PolarWikiPage = lazy(() => import('@/pages/wiki/polar/page'));
const PolarWikiArticlePage = lazy(() => import('@/pages/wiki/polar/article'));
const AdminPage = lazy(() => import('@/pages/admin/page'));
const NotFoundPage = lazy(() => import('@/pages/NotFound'));
const CustomerStoriesPage = lazy(() => import('@/pages/customer-stories/page'));
const BrandWikiPage = lazy(() => import('@/pages/wiki/brand/page'));
const BrandWikiArticlePage = lazy(() => import('@/pages/wiki/brand/article'));
const AllAsiliaPage = lazy(() => import('@/pages/safari-packages/tanzania/AllAsiliaPage'));
const LemalaPage = lazy(() => import('@/pages/safari-packages/tanzania/LemalaPage'));
const AndBeyondPage = lazy(() => import('@/pages/safari-packages/east-africa/AndBeyondPage'));
const PolarFinderPage = lazy(() => import('@/pages/polar-finder/page'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/custom', element: <CustomPage /> },
  { path: '/enterprise', element: <EnterprisePage /> },
  { path: '/africa', element: <AfricaPage /> },
  { path: '/polar', element: <PolarPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/destinations', element: <DestinationsPage /> },
  { path: '/destinations/:id', element: <DestinationDetailPage /> },
  { path: '/themes', element: <ThemesPage /> },
  { path: '/themes/:id', element: <ThemeDetailPage /> },
  { path: '/academy', element: <AcademyPage /> },
  { path: '/explore', element: <ExplorePage /> },
  { path: '/custom-service', element: <CustomServicePage /> },
  { path: '/wiki', element: <WikiPage /> },
  { path: '/wiki/africa', element: <AfricaWikiPage /> },
  { path: '/wiki/africa/:slug', element: <WikiArticlePage /> },
  { path: '/wiki/polar', element: <PolarWikiPage /> },
  { path: '/wiki/polar/:slug', element: <PolarWikiArticlePage /> },
  { path: '/customer-stories', element: <CustomerStoriesPage /> },
  { path: '/wiki/brand', element: <BrandWikiPage /> },
  { path: '/wiki/brand/:slug', element: <BrandWikiArticlePage /> },
  { path: '/safari-packages/tanzania/2027-all-asilia-northern-circuit', element: <AllAsiliaPage /> },
  { path: '/safari-packages/tanzania/2027-lemala-safari', element: <LemalaPage /> },
  { path: '/safari-packages/east-africa/2026-andbeyond-safari', element: <AndBeyondPage /> },
  { path: '/polar-finder', element: <PolarFinderPage /> },
  { path: '/admin', element: <AdminPage /> },
  { path: '*', element: <NotFoundPage /> },
];

export default routes;